import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HasRoleGuard } from 'src/app/core/guards/has-role.guard';
import { Role } from 'src/app/core/models/role.enum';
import { CaseCountingComponent } from './case-counting/case-counting.component';
import { CaseIndexComponent } from './case-index/case-index.component';
import { UnitCostsComponent } from './unit-costs/unit-costs.component';
import { UnitCostDetailComponent } from './unit-cost-detail/unit-cost-detail.component';
import { PosTerminalComponent } from './pos-terminal/pos-terminal.component';
import { PosDevicesComponent } from './pos-devices/pos-devices.component';
import { PosTransactionsComponent } from './pos-transactions/pos-transactions.component';

const routes: Routes = [
  {path: '', component:CaseIndexComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.User]}},
  {path: 'balances', component:CaseIndexComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.User]}},
  {path: 'counting', component:CaseCountingComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.User]}},
  // Birim maliyetleri artık yalnızca alım/satımdan değil, şubenin bütün defterinden çıkıyor:
  // alım/satım, şube transferi, açılış stoğu ve kasa hareketleri (alim-satim-maliyet.md, Faz 19).
  {path: 'unit-costs', component: UnitCostsComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.Wholesale]}},
  // Birim ve tarih aralığı sorgu parametresiyle gelir: /case/unit-costs/detail?currency=1&subType=0
  {path: 'unit-costs/detail', component: UnitCostDetailComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.Wholesale]}},
  // Rota, SYS_053 ile eklenen MenuItems.Link degeriyle birebir eslesmeli: menu DB'den okunuyor.
  {path: 'pos-terminals', component: PosTerminalComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.Admin]}},
  // POS cihaz entegrasyonu (pos-entegrasyonu.md); linkler SYS_090 ile eklenen MenuItems.Link ile aynı.
  {path: 'pos-devices', component: PosDevicesComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.Admin]}},
  // Mutabakat listesi kasiyere de açık; cihazdan iptal yetkisi sunucuda ayrıca denetlenir.
  {path: 'pos-transactions', component: PosTransactionsComponent, canActivate: [HasRoleGuard], data: {allowedRoles: [Role.User]}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseRoutingModule { }
